import { minLength, maxLength, required } from '@vuelidate/validators'

import { contractStartDate } from '@shared/validations/components'
import { ValidatorsUtil } from '@shared/utils/Validators'

export default {
  address: {
    zipCode: required,
    location: ValidatorsUtil.isLocation,
  },
  contractNumber: {},
  contractStartDate: {
    ...contractStartDate,
  },
  persons: {
    required,
    minLength: minLength(1),
    maxLength: maxLength(7),
    duplicatedPersons: ValidatorsUtil.hasNoDuplicatedPersons,
  },
  salesPartnerEmail: {
    email: ValidatorsUtil.isMail,
  },
}
